import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AppInsightsService {
  private appInsights: ApplicationInsights;

  constructor() {
    const angularPlugin = new AngularPlugin();
    this.appInsights = new ApplicationInsights({
      config: {
        connectionString: environment.APP_INSIGHTS_CONN_STRING, 
        extensions: [angularPlugin],
        extensionConfig: {
          [angularPlugin.identifier]: { router: null }
        }
      }
    });
    this.appInsights.loadAppInsights();
  }

  logPageView(name?: string, url?: string) {
    this.appInsights.trackPageView({ name, uri: url });
  }

  logEvent(name: string, properties?: any) {
    this.appInsights.trackEvent({ name }, properties);
  }

  logError(error: Error, properties?: any) {
    this.appInsights.trackException({ exception: error });
  }
}
